export enum DateRangeFilterTestIds {
  WRAPPER = 'range-date-wrapper',
  DATE_SHORTCUT_PREFIX = 'date-shortcut-',
  MINIMIZED_BUTTON = 'date-range-filter-minimized-button',
}
